@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;

.card {
    display: flex;
    align-items: center;
    gap: 16px;
    box-sizing: border-box;
    width: 100%;
    max-width: 360px;
    min-height: 86px;
    padding: 6px 16px;
    text-align: left;
    color: v.$palette-gray-900;
    background-color: v.$palette-white;
    border: 1px solid v.$palette-dirty-40;
    border-radius: 10px;
    box-shadow: 0 0 0 0 transparent;
    cursor: pointer;
    transition: v.$transition;
    font-family: v.$primary-font;
    outline: none;

    @media (max-width: 768px) {
        max-width: none;
    }

    &:hover {
        border-color: v.$palette-orange-1;
    }

    &:focus-visible {
        border-color: v.$palette-orange-1;
        box-shadow: none;
    }
}

.selected {
    border-color: v.$palette-orange-1;
    box-shadow: none;
}

.radio {
    position: relative;
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    border: 1.5px solid v.$palette-dirty-50;
    border-radius: 50%;
    background-color: v.$palette-white;

    &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: transparent;
        transform: translate(-50%, -50%);
    }
}

.radioSelected {
    border-color: v.$palette-orange-1;

    &::after {
        background-color: v.$palette-orange-1;
    }
}

.content {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
    min-width: 0;
}

.title {
    margin: 0;
    @include t.text(16px, 26px, 600);
    color: v.$palette-gray-900;
}

.description {
    margin: 0;
    @include t.text(12px, 20px, 400);
    color: v.$palette-gray-900;
}

.info {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;

    path {
        transition: v.$transition;
    }

    @media (pointer: fine) {
        &:hover path {
            fill: v.$palette-orange-2;
        }
    }
}

.tooltipContent {
    max-width: 280px;
}
